import { useEffect, useState } from 'react';

import { fetchDailyGameStatus } from '~/api/gameSessionApi';
import { type DailyGameStatus } from '~/types';

/**
 * Hook to manage the daily game status.
 *
 * Returns:
 * - error: string | null containing any error messages
 * - dailyGameStatus: current game session data or null if not loaded
 */
export function useDailyGameStatus() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [dailyGameStatus, setDailyGameStatus] =
    useState<DailyGameStatus | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const dailyGameStatusData = await fetchDailyGameStatus();
        setDailyGameStatus(dailyGameStatusData);
      } catch (err) {
        console.error('Error fetching daily game status:', err);
        setError(
          'Failed to load the daily game status. Please try again later.'
        );
      } finally {
        setIsLoading(false);
      }
    })();
  }, []); // Empty dependency array since we only want this to run once

  return { isLoading, error, dailyGameStatus };
}
